<div class="d-flex align-items-center" (click)="saveToLater()">
  <img class="move-icon pr-1" [src]="imageRoute" alt="mover a carrito" />
  <p class="font-omicron-bold color-omicron mb-0">
    {{ buttonText }}
  </p>
</div>